module.exports = __webpack_public_path__ + "static/img/作品41.2725178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品41.png
// module id = b0hu
// module chunks = 1